import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/notater',
    name: 'Notater',
    component: () => import('./views/Notater.vue')
  }
]

export default routes
